<template>
	<div
		class="modal-container privacy-policy"
		:class="{ 'modal-x-large': printText }"
	>
		<header>
			<h4>{{ title }}</h4>
			<button
				v-if="!printText"
				@click="close"
			>
				<i class="fa fa-times"></i>
			</button>
		</header>
		<section>
			<div v-html="term.termsText"></div>
		</section>
		<div
			v-if="printText"
			class="modal-footer"
		>
			<button @click="print(term.termsText)">
				{{ printText }}
			</button>
			<button
				@click="close"
				class="button-unwind"
			>
				Close
			</button>
		</div>
	</div>
</template>

<script>
	import $modal from '@core/services/modal';

	export default {
		name: 'modalLegalTerm',
		props: ['modal'],
		data() {
			return {
				term: null,
				title: '',
				printText: null,
			};
		},
		created() {
			this.term = this.modal.passedData.term;
			this.title = this.modal.passedData.title;
			this.printText = this.modal.passedData.printText;
		},
		methods: {
			print(text) {
				const printWindow = window.open('', '', 'height=600,width=800');
				printWindow.document.write(text);
				printWindow.document.close();
				printWindow.focus();
				printWindow.print();
				printWindow.close();
			},
			close() {
				$modal.close();
			},
		},
	};
</script>

<style scoped>
	.modal-container {
		padding-bottom: 15px;
	}
	.modal-container header {
		padding: 20px;
		position: relative;
		box-shadow: 1px 3px 15px 1px var(--black-10percent);
	}

	.modal-container section div {
		margin-top: 20px;
	}

	.modal-container header button {
		border: 0;
		background: 0;
		position: absolute;
		right: 5%;
	}
	.modal-container section {
		overflow: auto;
		padding: 5px 30px 0;
		text-align: justify;
	}

	.modal-container section div ul,
	.modal-container section div ol {
		padding-left: 20px;
	}
	.modal-container li ol {
		padding-left: 30px;
		width: 90%;
	}
</style>
